import { InjectionToken } from '@angular/core';

export const WINDOW_REF = new InjectionToken('WindowToken');

export const windowProvider = {
  provide: WINDOW_REF,
  useValue: window,
};
